import { fetchWrapper } from '../Helpers';

const baseUrl = `${process.env.REACT_APP_API_URL}/appointments`;

export const appointmentsService = {
   getAppointmentsLinks
};

function getAppointmentsLinks() {
    return fetchWrapper.get(`${baseUrl}/link`);
}